import { handleActions } from 'redux-actions';
import cloneDeep from 'lodash/cloneDeep';
import update from 'immutability-helper';
import _ from 'lodash';

import {
  fetchChannelEvent,
  fetchEventTemplates,
  fetchInteractions,
  fetchImageLibraryList,
  fetchLeagues,
  fetchTeams,
  copyToClipboard,
  changeChannelSocket,
  updateClientsMobileConnected,
  updateListClientsConnected,
  fetchInteractionAnalytics,
  onCloseDialogAnalytics,
  filterOption,
  closeDataListView,
  setCheckingMobileConnection,
  addTagCondition,
  removeTagCondition,
  clearTagCondition,
  setLogicalConnector,
} from './actions';

export const initialState = {
  channelId: null,
  event: null,

  templateList: [],
  templatePageSize: 10,

  interactionsList: [],
  interactionsPageSize: 10,

  editable: false,
  leagueSelected: null,
  gameSelected: null,

  leaguesList: [],
  teamsList: [],
  imageLibraryList: [],

  socket: null,
  listClientsConnected: [],
  clientsMobileConnected: [],

  analyticsDialog: false,
  interactionAnalytics: null,
  usersAnalytics: null,
  dataListView: false,
  checkingMobileConnection: false,
  listConditions: [],
  logicalConnector: {},
};

export const reducer = handleActions(
  {
    [fetchChannelEvent]: {
      next: (state, { payload }) => {
        let newLeagueSelected = null;
        let newGameSelected = null;
        let newEditableState = false;

        if (payload && payload.game) {
          const game = payload.game;

          newEditableState = game.editable ? true : false;

          if (game && game._id) {
            newLeagueSelected = game.leagueId;
            newGameSelected = game.gameId;
          }
        }

        const newState = update(state, {
          event: { $set: payload || {} },
          leagueSelected: { $set: newLeagueSelected || null },
          gameSelected: { $set: newGameSelected || null },
          editable: { $set: newEditableState || false },
        });

        return newState;
      },
      throw: state => {
        return update(state, {
          event: { $set: {} },
          leagueSelected: { $set: null },
          gameSelected: { $set: null },
          editable: { $set: false },
        });
      },
    },
    [fetchEventTemplates]: {
      next: (state, { payload }) => {
        const newState = update(state, {
          templateList: { $set: payload || [] },
        });

        return newState;
      },
      throw: state => {
        return update(state, {
          templateList: { $set: [] },
        });
      },
    },
    [setCheckingMobileConnection]: {
      next: (state, { payload }) => {
        const newState = update(state, {
          checkingMobileConnection: { $set: payload || false },
        });

        return newState;
      },
      throw: state => {
        return update(state, {
          checkingMobileConnection: { $set: false },
        });
      },
    },
    [fetchInteractions]: {
      next: (state, { payload }) => {
        const newState = update(state, {
          interactionsList: { $set: payload || [] },
        });

        return newState;
      },
      throw: state => {
        return update(state, {
          interactionsList: { $set: [] },
        });
      },
    },
    [fetchImageLibraryList]: {
      next: (state, { payload }) => {
        const newState = update(state, {
          imageLibraryList: { $set: payload || [] },
        });
        return newState;
      },
      throw: state => {
        return update(state, {
          imageLibraryList: { $set: [] },
        });
      },
    },
    [fetchLeagues]: {
      next: (state, { payload }) => {
        return update(state, {
          leaguesList: { $set: payload || [] },
        });
      },
      throw: state => {
        return update(state, {
          leaguesList: { $set: [] },
        });
      },
    },
    [fetchTeams]: {
      next: (state, { payload }) => {
        const newState = update(state, {
          teamsList: { $set: payload || [] },
        });

        return newState;
      },
      throw: state => {
        return update(state, {
          teamsList: { $set: [] },
        });
      },
    },
    [copyToClipboard]: {
      next: (state, { payload }) => {
        //temporary input to copy the url
        var tempInput = document.createElement('input');
        document.body.appendChild(tempInput);
        tempInput.setAttribute('id', 'tempInput_id');
        document.getElementById('tempInput_id').value = payload;
        tempInput.select();
        document.execCommand('copy');
        document.body.removeChild(tempInput);

        return state;
      },
      throw: state => {
        return state;
      },
    },
    [changeChannelSocket]: {
      next: (state, { payload }) => {
        const newState = update(state, {
          socket: { $set: payload || null },
          listClientsConnected: { $set: [] },
        });

        return newState;
      },
      throw: state => {
        return update(state, {
          socket: { $set: null },
          listClientsConnected: { $set: [] },
        });
      },
    },
    [updateClientsMobileConnected]: {
      next: (state, { payload }) => {
        const newState = update(state, {
          clientsMobileConnected: { $set: payload || [] },
        });

        return newState;
      },
      throw: state => {
        return update(state, {
          clientsMobileConnected: { $set: [] },
        });
      },
    },
    [updateListClientsConnected]: {
      next: (state, { payload }) => {
        let listClientsConnected = [];

        if (payload && payload.length) {
          listClientsConnected = payload;
        }

        const newState = update(state, {
          listClientsConnected: { $set: listClientsConnected || [] },
        });
        return newState;
      },
      throw: state => {
        return update(state, {
          listClientsConnected: { $set: [] },
        });
      },
    },
    [fetchInteractionAnalytics]: {
      next: (state, { payload }) => {
        if (_.isEmpty(payload)) {
          payload = { isNull: true };
        }
        const newState = update(state, {
          interactionAnalytics: { $set: payload || null },
          analyticsDialog: { $set: true || false },
        });

        return newState;
      },
      throw: state => {
        return update(state, {
          interactionAnalytics: { $set: null },
          analyticsDialog: { $set: false },
        });
      },
    },
    [filterOption]: {
      next: (state, { payload }) => {
        const newState = update(state, {
          usersAnalytics: { $set: payload || null },
          dataListView: { $set: true || false },
        });

        return newState;
      },
      throw: state => {
        return update(state, {
          usersAnalytics: { $set: null },
          dataListView: { $set: false },
        });
      },
    },
    [onCloseDialogAnalytics]: {
      next: (state, { payload }) => {
        const newState = update(state, {
          analyticsDialog: { $set: payload || false },
        });

        return newState;
      },
      throw: state => {
        return update(state, {
          analyticsDialog: { $set: false },
        });
      },
    },
    [closeDataListView]: {
      next: (state, { payload }) => {
        const newState = update(state, {
          dataListView: { $set: payload || false },
        });

        return newState;
      },
      throw: state => {
        return update(state, {
          dataListView: { $set: false },
        });
      },
    },
    [addTagCondition]: {
      next: (state, { payload }) => {
        const newState = update(state, {
          listConditions: { $push: [payload] },
        });

        return newState;
      },
      throw: state => {
        return update(state, {
          listConditions: { $set: [] },
        });
      },
    },
    [removeTagCondition]: {
      next: (state, { payload }) => {
        if (payload >= 0 && payload < state.listConditions.length) {
          const newState = update(state, {
            listConditions: { $splice: [[payload, 1]] },
          });
          return newState;
        }
        return state;
      },
      throw: state => {
        return update(state, {
          listConditions: { $set: [] },
        });
      },
    },
    [clearTagCondition]: {
      next: (state, { payload }) => {
        return update(state, {
          listConditions: { $set: [] },
        });
      },
      throw: state => {
        return update(state, {
          listConditions: { $set: [] },
        });
      },
    },
    [setLogicalConnector]: {
      next: (state, { payload }) => {
        return update(state, {
          logicalConnector: { $set: payload },
        });
      },
      throw: state => {
        return update(state, {
          logicalConnector: { $set: {} },
        });
      },
    },
  },
  cloneDeep(initialState)
);

export default reducer;
